const MobileStiva = () => import(/* webpackChunkName: "Open router view" */ "../../views/MobileStiva/MobileStiva.vue");
const HistoryFIle = () => import(/* webpackChunkName: "application.vue"*/ "../../views/MobileStiva/HistoryFile.vue");


const MobileToStiva = [{
  path: "mobileStiva",
  name: "Mobile Stiva",
  redirect: {
    name: "History File"
  },
  component: MobileStiva,

  children: [
    {
      path: "historyFile",
      name: "History File",
      component: HistoryFIle
    }
  ]
}];

export default MobileToStiva;

